import { memo, lazy } from 'react';
import { Loader } from '@client/components/common/Loader';
import { PageContainer } from '@client/components/common/PageContainer';
import { Modal } from '../../globals/Modal';
import type { LoginModalProps } from '../common/LoginModalProps.interface';

const LoginLoader = lazy(() => import('./Login'));

export const openLoginModal = (props?: LoginModalProps) => Modal.show({
  body: (
    <Loader
      load={LoginLoader}
      {...props}
    />
  ),
  buttons: [],
});

export default memo(() => (
  <PageContainer>
    <Loader
      load={LoginLoader}
    />
  </PageContainer>
));
